<template>
  <ContentWrap>
    <el-form
      ref="queryFormRef"
      :inline="true"
      :model="queryParams"
      class="-mb-15px"
      label-width="80px"
    >
      <el-form-item label="模板名称" prop="templateName">
        <el-input
          v-model="queryParams.templateName"
          class="!w-240px"
          clearable
          placeholder="请输入模板名称"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="价格类型" prop="priceType">
        <el-select
          :model-value="queryParams.priceType as any"
          @update:model-value="(val: any) => queryParams.priceType = val"
          class="!w-240px"
          clearable
          placeholder="请选择价格类型"
        >
          <el-option label="固定价" :value="0" />
          <el-option label="加价" :value="1" />
          <el-option label="折扣率" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select
          :model-value="queryParams.status as any"
          @update:model-value="(val: any) => queryParams.status = val"
          class="!w-240px"
          clearable
          placeholder="请选择状态"
        >
          <el-option
            v-for="dict in getIntDictOptions(DICT_TYPE.COMMON_STATUS)"
            :key="dict.value"
            :label="dict.label"
            :value="dict.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleQuery">
          <Icon class="mr-5px" icon="ep:search" />
          搜索
        </el-button>
        <el-button @click="resetQuery">
          <Icon class="mr-5px" icon="ep:refresh" />
          重置
        </el-button>
        <el-button
          v-hasPermi="['hotel:price-template:create']"
          plain
          type="primary"
          @click="openForm('create')"
        >
          <Icon class="mr-5px" icon="ep:plus" />
          新增
        </el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list">
      <el-table-column align="center" label="模板名称" prop="templateName" min-width="150">
        <template #default="scope">
          <el-tag type="info">{{ scope.row.templateName }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="价格类型" prop="priceType">
        <template #default="scope">
          <el-tag :type="getPriceTypeTag(scope.row.priceType)">
            {{ getPriceTypeLabel(scope.row.priceType) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="价格值" prop="priceValue">
        <template #default="scope">
          <span v-if="scope.row.priceType === 2">{{ scope.row.priceValue }}%</span>
          <span v-else class="text-red-500 font-bold">¥{{ scope.row.priceValue }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="适用星期" prop="applicableDays" min-width="150">
        <template #default="scope">
          <span>{{ getApplicableDaysLabel(scope.row.applicableDays) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="日期范围" min-width="200">
        <template #default="scope">
          <span>{{ scope.row.startDate }} ~ {{ scope.row.endDate }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态" prop="status">
        <template #default="scope">
          <dict-tag :type="DICT_TYPE.COMMON_STATUS" :value="scope.row.status" />
        </template>
      </el-table-column>
      <el-table-column
        :formatter="dateFormatter"
        align="center"
        label="创建时间"
        prop="createTime"
        width="180"
      />
      <el-table-column align="center" label="操作" width="220">
        <template #default="scope">
          <el-button
            v-hasPermi="['hotel:price-template:update']"
            link
            type="primary"
            @click="openForm('update', scope.row.id)"
          >
            修改
          </el-button>
          <el-button
            v-hasPermi="['hotel:price-template:delete']"
            link
            type="danger"
            @click="handleDelete(scope.row.id)"
          >
            删除
          </el-button>
          <el-button link type="success" @click="handleApply(scope.row.id)">
            应用模板
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:limit="queryParams.pageSize"
      v-model:page="queryParams.pageNo"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>

  <Dialog v-model="dialogVisible" :title="dialogTitle">
    <el-form
      ref="formRef"
      v-loading="formLoading"
      :model="formData"
      :rules="formRules"
      label-width="100px"
    >
      <el-form-item label="店铺" prop="shopId">
        <el-select v-model="formData.shopId" placeholder="请选择店铺" filterable clearable>
          <el-option v-for="item in shopList" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="模板名称" prop="templateName">
        <el-input v-model="formData.templateName" placeholder="请输入模板名称" />
      </el-form-item>
      <el-form-item label="价格类型" prop="priceType">
        <el-select
          :model-value="formData.priceType as any"
          @update:model-value="(val: any) => formData.priceType = val"
          clearable
          placeholder="请选择价格类型"
        >
          <el-option label="固定价" :value="0" />
          <el-option label="加价" :value="1" />
          <el-option label="折扣率" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item label="价格值" prop="priceValue">
        <el-input-number
          v-model="formData.priceValue"
          :min="0"
          :precision="2"
          placeholder="请输入价格值"
        />
      </el-form-item>
      <el-form-item label="适用天数" prop="applicableDays">
        <el-input v-model="formData.applicableDays" placeholder="请输入适用天数" />
      </el-form-item>
      <el-form-item label="开始日期" prop="startDate">
        <el-date-picker
          v-model="formData.startDate"
          placeholder="请选择开始日期"
          type="date"
          value-format="YYYY-MM-DD"
        />
      </el-form-item>
      <el-form-item label="结束日期" prop="endDate">
        <el-date-picker
          v-model="formData.endDate"
          placeholder="请选择结束日期"
          type="date"
          value-format="YYYY-MM-DD"
        />
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="formData.status">
          <el-radio
            v-for="dict in getIntDictOptions(DICT_TYPE.COMMON_STATUS)"
            :key="dict.value"
            :value="dict.value"
          >
            {{ dict.label }}
          </el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button :loading="formLoading" type="primary" @click="submitForm">确 定</el-button>
      <el-button @click="dialogVisible = false">取 消</el-button>
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import { DICT_TYPE, getIntDictOptions } from '@/utils/dict'
import { dateFormatter } from '@/utils/formatTime'
import * as priceTemplateApi from '@/api/hotel/priceTemplate'
import { getShopSimpleList } from '@/api/hotel/platformShop'
import { CommonStatusEnum } from '@/utils/constants'

defineOptions({ name: 'HotelPriceTemplate' })

const message = useMessage()
const { t } = useI18n()

const loading = ref(true)
const total = ref(0)
const list = ref([])

// 店铺下拉列表
const shopList = ref<any[]>([])
const getShopList = async () => {
  const data = await getShopSimpleList()
  shopList.value = data || []
}

const queryParams = reactive<any>({
  pageNo: 1,
  pageSize: 20,
  templateName: undefined,
  priceType: undefined,
  status: undefined
})
const queryFormRef = ref()

const getList = async () => {
  loading.value = true
  try {
    const data = await priceTemplateApi.getPriceTemplatePage(queryParams)
    list.value = data.list
    total.value = data.total
  } finally {
    loading.value = false
  }
}

// 价格类型映射
const priceTypeMap: Record<number, { label: string; tag: string }> = {
  0: { label: '固定价', tag: 'primary' },
  1: { label: '加价', tag: 'warning' },
  2: { label: '折扣率', tag: 'success' }
}
const getPriceTypeLabel = (t: number) => priceTypeMap[t]?.label || `类型${t}`
const getPriceTypeTag = (t: number) => priceTypeMap[t]?.tag || 'info'

// 适用星期映射
const dayLabels = ['', '周一', '周二', '周三', '周四', '周五', '周六', '周日']
const getApplicableDaysLabel = (days: string) => {
  if (!days) return '-'
  if (days === '1,2,3,4,5,6,7') return '每天'
  return days.split(',').map(d => dayLabels[Number(d)] || d).join('、')
}

const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

const resetQuery = () => {
  queryFormRef.value.resetFields()
  handleQuery()
}

const dialogVisible = ref(false)
const dialogTitle = ref('')
const formLoading = ref(false)
const formType = ref('')
const formData = ref<priceTemplateApi.PriceTemplateVO>({
  id: 0,
  shopId: undefined,
  spuId: 0,
  templateName: '',
  priceType: 0,
  priceValue: 0,
  applicableDays: '',
  startDate: '',
  endDate: '',
  status: CommonStatusEnum.ENABLE,
  createTime: undefined as any
})
const formRules = reactive({
  templateName: [{ required: true, message: '模板名称不能为空', trigger: 'blur' }],
  priceType: [{ required: true, message: '价格类型不能为空', trigger: 'change' }],
  priceValue: [{ required: true, message: '价格值不能为空', trigger: 'blur' }],
  status: [{ required: true, message: '状态不能为空', trigger: 'change' }]
})
const formRef = ref()

const openForm = async (type: string, id?: string | number) => {
  dialogVisible.value = true
  dialogTitle.value = t('action.' + type)
  formType.value = type
  resetForm()
  if (id) {
    formLoading.value = true
    try {
      formData.value = await priceTemplateApi.getPriceTemplate(id)
    } finally {
      formLoading.value = false
    }
  }
}

const submitForm = async () => {
  if (!formRef) return
  const valid = await formRef.value.validate()
  if (!valid) return
  formLoading.value = true
  try {
    const data = formData.value
    if (formType.value === 'create') {
      await priceTemplateApi.createPriceTemplate(data)
      message.success(t('common.createSuccess'))
    } else {
      await priceTemplateApi.updatePriceTemplate(data)
      message.success(t('common.updateSuccess'))
    }
    dialogVisible.value = false
    await getList()
  } finally {
    formLoading.value = false
  }
}

const resetForm = () => {
  formData.value = {
    id: 0,
    shopId: 0,
    spuId: 0,
    templateName: '',
    priceType: 0,
    priceValue: 0,
    applicableDays: '',
    startDate: '',
    endDate: '',
    status: CommonStatusEnum.ENABLE,
    createTime: undefined as any
  }
  formRef.value?.resetFields()
}

const handleDelete = async (id: string | number) => {
  try {
    await message.delConfirm()
    await priceTemplateApi.deletePriceTemplate(id)
    message.success(t('common.delSuccess'))
    await getList()
  } catch {}
}

const handleApply = async (id: string | number) => {
  try {
    await message.confirm('确认应用该价格模板？')
    await priceTemplateApi.apply(id)
    message.success('应用成功')
  } catch {}
}

onMounted(() => {
  getList()
  getShopList()
})
</script>
